import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Box, Button, Grid, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import { selectOrganisation } from '@/app/slices/organisationSlice'

import PublicAppBar from '../../MainAppBar/PublicAppBar'

const classes = {
    root: {
        backgroundColor: 'background.paper',
        borderRadius: 1,
        border: (theme) => `1px ${theme.palette.grey[300]} solid`,
        width: '100%',
        height: 'calc(100vh - 64px)',
        gap: 3,
    },
    sorryImage: {
        width: '700px',
    },
    sorryMessage: {
        gap: 1,
    },
}

const ErrorPageContainer = ({ linkHref, linkText, subtitle, title }) => {
    const { t } = useTranslation()

    const organisation = useSelector(selectOrganisation)

    return (
        <>
            <PublicAppBar
                organisationLogo={organisation?.logoUri}
                organisationName={organisation?.name}
            />
            <Grid
                component="section"
                xs={12}
                container
                item
            >
                <Box
                    alignItems="center"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    p={12}
                    sx={classes.root}
                >
                    <Box
                        alt="Sorry"
                        component="img"
                        src="sorry.svg"
                        sx={classes.sorryImage}
                    />

                    <Box
                        alignItems="center"
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        sx={classes.sorryMessage}
                    >
                        <Typography variant="h4">{t(title)}</Typography>
                        <Typography variant="body2">{t(subtitle)}</Typography>
                    </Box>

                    <Button
                        color="primary"
                        size="large"
                        variant="contained"
                        onClick={() => {
                            window.location.href = linkHref
                        }}
                    >
                        {t(linkText)}
                    </Button>
                </Box>
            </Grid>
        </>
    )
}

ErrorPageContainer.propTypes = {
    linkHref: PropTypes.string,
    linkText: PropTypes.string,
    subtitle: PropTypes.string,
    title: PropTypes.string,
}

export default ErrorPageContainer
